import {useMemo} from 'react';
import {DISTANCE_CALC_TYPES} from '../../../lib/types';
import {FilterProps} from '../filter-types';

export function useDistanceCalcTypeFilter(
    distanceCalcType: string,
    onChange: (value: string) => void
): FilterProps {
    return useMemo(() => ({
        label: 'Distance Calculation Type',
        data: DISTANCE_CALC_TYPES,
        value: distanceCalcType,
        required: true,
        onChange,
        children: [
            (item: any): string => item.value,
            (item: any) => item.name,
        ],
        ['data-testid']: 'distance-calc-type-dropdown',
    }), [distanceCalcType, onChange]);
}
